import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { clearTypeahed, fetchLicenseEnumData } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class LicenseIncorrectDataTypeahead extends Component {
    static propTypes = {
        fetchLicenseEnumData: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.object,
        ]),
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        suggestions: [],
        renderMultiSuggestion
    };

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.fetchLicenseEnumData(LicenseIncorrectDataTypeahead.name, 'licenseVerifyKind');
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        const options = this.props.suggestions.map(licenseVerifyKind =>
            ({ label: licenseVerifyKind.name, value: licenseVerifyKind.id }));

        return (
            <MultiTypeahead
                options={options}
                isLoading={this.state.isLoading}
                value={this.props.value}
                titleId="incorrectData"
                animatedPlaceholder
                onChangeSuggestion={this.props.onChangeSuggestion}
                onFocus={this.onFocus}
                formatOptionLabel={this.props.renderMultiSuggestion}
                handleSuggestionsClearRequested={this.props.clearTypeahed}
                error={this.props.error}
                isClearable
                t={this.props.t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === LicenseIncorrectDataTypeahead.name
            ? typeahead.list
            : LicenseIncorrectDataTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchLicenseEnumData,
    clearTypeahed
})(LicenseIncorrectDataTypeahead);
